module.exports = __webpack_public_path__ + "static/media/ev1.56e87fc1.webp";